import { createSlice } from '@reduxjs/toolkit';

const resourcesSlice = createSlice({
  name: 'resources',
  initialState: {},
  reducers: {
    hydrate: (state, { payload }) => {
      return { ...state, ...payload };
    },
  },
});

export const { hydrate } = resourcesSlice.actions;
export default resourcesSlice.reducer;
